"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var fixDependenciesPlugin_exports = {};
__export(fixDependenciesPlugin_exports, {
  fixDependenciesPlugin: () => fixDependenciesPlugin
});
module.exports = __toCommonJS(fixDependenciesPlugin_exports);
var import_vxrn = require("vxrn");
function _type_of(obj) {
  "@swc/helpers - typeof";
  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function fixDependenciesPlugin(options) {
  var patches = [];
  for (var key in options) {
    var value = options[key];
    if (value && (typeof value === "undefined" ? "undefined" : _type_of(value)) === "object") {
      patches.push({
        module: key,
        patchFiles: value
      });
    }
  }
  return {
    name: "one-fix-dependencies",
    enforce: "pre",
    async configResolved(config) {
      await (0, import_vxrn.applyDependencyPatches)(patches, config);
    }
  };
}
//# sourceMappingURL=fixDependenciesPlugin.js.map
